import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';

export default function GridModal2({
    show,
    onHide = () => {},
    title,
    children,
    setShow,
  }) {
  return (
    <Modal show={show} 
    aria-labelledby="contained-modal-title-vcenter"
    centered>
      <Modal.Header closeButton={true} onHide={() => setShow(false)}>
        <Modal.Title id="contained-modal-title-vcenter">
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="grid-example">
          {children}
      </Modal.Body>
    </Modal>
  );
}

